import popupStyles from "./deleteConfirmation.module.css";
import { IPopupWithoutProps } from "../../../types/types";
import venchyImg from "../../../images/questionnaire_doctor.png";
import { tWithKeyAttr as t } from "../../../i18nHelper";

function DeleteConfirmation({
  onClose,
  onDelete,
  text,
  userName,
  btnText = t("CONFIRM"),
  nextText,
  hideCloseButton
}: IPopupWithoutProps & {
  onDelete: () => void;
  text: string;
  userName?: string;
  btnText?: string;
  nextText?: String;
  hideCloseButton?: boolean;
}) {
  return (
    <article
      className={popupStyles.popup}
      data-testid="delete-confirmation-popup"
    >
      <img className={popupStyles.popup__img} src={venchyImg} alt={t("VENCHY_ALT")} />
      <p className={popupStyles.popup__text}>
        {text}
        {userName && (
          <span className={popupStyles.popup__highlight}> {userName} </span>
        )}
        {nextText}
      </p>
      <div className={popupStyles.popup__buttons}>
        <button
          className={`button ${popupStyles.popup__nextBtn} hover`}
          data-testid="confirm-deletion-button"
          onClick={() => {
            onDelete();
            onClose();
          }}
        >
          {btnText}
        </button>

        {!hideCloseButton && (
          <button
            className={`button ${popupStyles.popup__cancelBtn} hover`}
            data-testid="cancel-deletion-button"
            onClick={onClose}
          >
            {t("CANCEL")}
          </button>
        )}
      </div>
    </article>
  );
}

export default DeleteConfirmation;
